import styled from 'styled-components';
import React, { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { Button, CircularProgress } from '@material-ui/core';
import { InertiaLink } from '@inertiajs/inertia-react';
import { getCookieValue } from "../utils/getCookieValue";
import { Trans } from "../utils/i18n";

import DeleteIcon from '@material-ui/icons/Delete';
import Grid from "@material-ui/core/Grid";
import {IconButton} from "@mui/material";
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";
import { isEqual } from 'lodash';

export default function DropzoneForm({form, values, ...props}) {
  const [status, setStatus] = useState('initial'); // initial | validating | valid | uploading | uploaded | upload-failed
  const [responseMessage, setResponseMessage] = useState('');
  const [errors, setErrors] = useState([]);
  const {acceptedFiles, getRootProps, getInputProps} = useDropzone({
      // maxFiles: 1,
      name: 'file'+props.type,
  });
    const orderEntryDispatch = useFormStateDispatch();
    const { files } = useFormState();

  useEffect(() => {
      const asyncFunction = async ( droppedFile ) => {
          try {
              const formData = new FormData();
              formData.append('file', droppedFile);
              formData.append('type', props.type || 'receipt');

              setStatus('validating');
              const uploadResponse = await fetch(route('file.upload'), {
                  headers: {
                      'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN'),
                      'X-Requested-With': 'XMLHttpRequest',
                  },
                  method: 'POST',
                  body: formData,
              });

              const { message, errors, file } = await uploadResponse.json();

              if (uploadResponse.status === 200) {
                  setStatus('valid');
                  setErrors([]);
                  setResponseMessage('');
                  const newImage = URL.createObjectURL(droppedFile);

                  form.change("files", [
                        ...(values.files ?? []),
                        {
                            serverResponse: file,
                            fileName: droppedFile.path,
                            previewImage: newImage,
                            type: props.type,
                        }
                  ])

                  orderEntryDispatch({ type: 'addFileUpload', value: {
                          serverResponse: file,
                          fileName: droppedFile.path,
                          previewImage: newImage,
                          type: props.type,
                      } });
                  return;
              }
              setStatus('initial');
              setResponseMessage(message);
              if(errors) {
                  setErrors(errors);
              }
          } catch (error) {
            console.error(error);
              setStatus('initial');
              setResponseMessage(<Trans i18nKey="dropzone.errorResponseMessage">An error occurred. Please try again!</Trans>);
              setErrors([]);
          }
      }

      acceptedFiles.forEach( asyncFunction );
  }, [acceptedFiles]);

  return (
    <StyledDropzone>
      <div {...getRootProps({ className: "dropzone", })}>
        <input {...getInputProps({ name: 'file'+props.type })} />
        <StyledDropField status={status}><Trans i18nKey="dropzone.dropFieldStatus">Drag 'n' drop one file here, or click to select a file</Trans></StyledDropField>
      </div>
      <StyledFilename>
          <Trans i18nKey="dropzone.files">Files: </Trans>
      </StyledFilename>
      <Grid container spacing={3}>
          <Grid item xs={12}>
              {
                  files
                      .map(
                      (item, key) =>
                      <Grid container spacing={3} style={{ display: item.type === props.type ? '' : 'none' }}>
                          <Grid item xs={12} sm={2}>
                              {
                                  item.serverResponse.mimetype === 'application/pdf' && <PreviewImageSVG aria-hidden="true" focusable="false" data-prefix="fas" data-icon="file-pdf" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" className="svg-inline--fa fa-file-pdf fa-w-12 fa-3x">
                                      <path fill="currentColor" d="M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z" className=""></path>
                                  </PreviewImageSVG>
                              }
                              {
                                  item.serverResponse.mimetype !== 'application/pdf' && <PreviewImage src={item.previewImage} alt={'Preview image'} />
                              }
                          </Grid>
                          <Grid item xs={12} sm={7}>
                              { item.fileName }
                              <hr />
                          </Grid>
                          <Grid item xs={12} sm={3} style={{ display: 'flex', alignItems: 'start', justifyContent: 'flex-end' }}>
                              <IconButton
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                      orderEntryDispatch({ type: 'removeFileUpload', value: key });
                                      form.change("files", (values.files ?? []).filter((file) => !isEqual(file, item)));
                                  }}
                              >
                                  <DeleteIcon />
                              </IconButton>
                          </Grid>
                      </Grid>
                  )
              }
          </Grid>
      </Grid>
      {['validating', 'uploading'].includes(status) && <StyledCircularProgress size={25} />}
      {['initial', 'valid'].includes(status) && <h4>{responseMessage}</h4>}
        <ul>
            {
                errors.map && errors.map(item => <li>
                    <Trans i18nKey="dropzone.row">Row</Trans> {item.row}
                    <ul>
                        {
                            item.errors && item.errors.map(item => <li>{item}</li>)
                        }
                    </ul>
                </li>)
            }
            {
                !errors.map && Object.values(errors).map(item => <li>
                    {
                        item && item.join(', ')
                    }
                </li>)
            }
        </ul>
    </StyledDropzone>
  );
};

const PreviewImage = styled.img`
  height: 70px;
  width: 70px;
  object-fit: cover;
`;

const PreviewImageSVG = styled.svg`
  height: 50px;
  width: 50px;
  object-fit: cover;
`;

const StyledDropzone = styled.div`
`;

const StyledDropField = styled.p`
  padding: 100px 50px;
  border: 2px dashed currentColor;
  text-align: center;
  opacity: ${({ status }) => ['uploading'].includes(status) ? '50%' : '100%'};
  cursor: ${({ status }) => ['uploading'].includes(status) ? 'not-allowed' : 'pointer'};
`;

const StyledFilename = styled.h4`
  display: inline-block;
  margin-right: 30px;
  vertical-align: middle;
`;

const StyledCircularProgress = styled(CircularProgress)`
  vertical-align: middle;
`;

const StyledButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 30px;
  margin: 30px 0;
`;

const StyledLink = styled(InertiaLink)`
  text-decoration: none;
`;
